import './growl.scss';
import component from './growl.component'
import service from './growl.service'
import provider from './growl.provider'

const module = angular.module('growl', [])
.config(function(growlProvider) {
	"ngInject"

	//growlProvider.globalTimeToLive(3000);
})
.component('growl', component)
.service('growlMessages', service)
.provider('growl', provider)
.name;

export default module;



// WEBPACK FOOTER //
// ./app/components/growl/growl.js